import React from 'react';
import urls, { codeUrl } from '@/constants/urls';
import CreatedWithUrlToast from '@/components/toasts/CreatedWithUrlToast';

const CollectionCreatedToast = ({ name, code }) => (
  <CreatedWithUrlToast
    className="aridhia-collection-created-toast"
    messageId="toast.your.collection"
    name={name}
    url={codeUrl(urls.COLLECTIONS, code)}
  />
);

export default CollectionCreatedToast;
